import {Button, Group, Text} from '@mantine/core';
import React, {ReactNode} from 'react';

import ModalFooter from 'ui-library/modals/ModalFooter';
import type {RunModalProps} from 'ui-library/runModal';

export type RemoveContainerContentModalProps = RunModalProps<boolean> & {
  itemName: ReactNode;
};

/** Confirms removing one content from a container. Resolves `true` when the user confirms. */
export default function RemoveContainerContentModal({
  close,
  itemName,
}: RemoveContainerContentModalProps): JSX.Element {
  return (
    <>
      <Text>Remove {itemName} from this container? Its other contents and quantity stay as they are.</Text>
      <ModalFooter>
        <Group position="right">
          <Button variant="secondary" onClick={() => close(false)}>
            Cancel
          </Button>
          <Button variant="warn" onClick={() => close(true)}>
            Remove
          </Button>
        </Group>
      </ModalFooter>
    </>
  );
}
